const multipleSaleText = {
  'multipleSaleText.withMultipleSale':
    'يجب شراء على الأقل {minSaleCount} قطعة، ويجب أن يكون العدد مضاعف ل {multipleSaleCount}',
  'multipleSaleText.withoutMultipleSale': 'يجب شراء على الأقل {minSaleCount} قطعة',
  'multipleSaleText.withoutMinSaleCount': 'يجب أن يكون العدد مضاعف ل {multipleSaleCount}',
};

export default multipleSaleText;
